import React from "react"
import { has } from "lodash"

import AddNewReleaseConfig from "./AddNewRelease"

import { v4 as uuidv4 } from "uuid"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faPlus, faSpinner } from "@fortawesome/free-solid-svg-icons"

class ReleaseForm extends React.Component {
    constructor() {
        super()
        this.pageSize = 10
        this.state = {
            error: "",
            currentRelease: [],
            addNewRelease: false,
            history: [],
            isLoading: true,
            page: 1,
            loadMore: true,
            initialLoad: true,
            selectedEngineVersion: null,
            showEngineVersionDropdown: false,
        }
        this.engineVersionDropDownRef = React.createRef()
    }
    componentDidMount() {
        this.getCurrentRelease(this.state.selectedEngineVersion);
        this.getVersionHistory(0);
        window.addEventListener("click", this.hideDropDown);
    }
    getVersionHistory = (offset) => {
        fetch(`/api/data/project/${this.props.projectId}/version/list?limit=${this.pageSize}&offset=${offset}`)
            .then(res => res.json())
            .then(data => {
                if (has(data, "error")) { throw data }
                var loadMore = true
                if (data.results.length < this.pageSize) {
                    loadMore = false
                }
                this.setState(prevState => {
                    return {
                        history: [...prevState.history, ...data.results.sort((a, b) => b.code - a.code)],
                        isLoading: false,
                        initialLoad: false,
                        loadMore: loadMore
                    }
                })
            })
            .catch(data => {
                this.setState({
                    error: `Server: ${data.error}`,
                    isLoading: false
                })
            })
    }
    getCurrentRelease = (engineVersion) => {
        if (!engineVersion) {
            return;
        }
        fetch(`/api/data/project/${this.props.projectId}/release/list?engine_version=${engineVersion}`)
            .then(res => res.json())
            .then(data => {
                if (has(data, "error")) { throw data }
                this.setState({
                    currentRelease: data.result,
                    addNewRelease: false,
                })
            })
            .catch(data => this.setState({ error: `Server: ${data.error}` }))
    }
    hideDropDown = (e) => {
        if (this.state.showEngineVersionDropdown === true && !this.engineVersionDropDownRef.current.contains(e.target)) {
            this.setState({
                showEngineVersionDropdown: false
            });
        }
    }
    addNewRelease = (e) => {
        e.preventDefault()
        this.setState({
            addNewRelease: true
        })
    }
    cancelNewRelease = (e) => {
        e.preventDefault()
        this.setState({
            addNewRelease: false,
        })
    }
    toggleEngineVersionDropDown = (e) => {
        this.setState(prevState => {
            return {
                showEngineVersionDropdown: !prevState.showEngineVersionDropdown
            }
        })
    }
    submitEngineVersionDropDownValue = (version) => {
        this.setState({
            selectedEngineVersion: version,
            showEngineVersionDropdown: false
        })
        this.getCurrentRelease(version);
    }
    loadMore = (e) => {
        this.setState(prevState => {
            return {
                page: prevState.page + 1,
                isLoading: true
            }
        }, () => this.getVersionHistory((this.state.page - 1) * this.pageSize))
        e.preventDefault()
        e.stopPropagation()
    }
    render() {
        const { addNewRelease, currentRelease, history, loadMore, isLoading, initialLoad, selectedEngineVersion, showEngineVersionDropdown } = this.state
        const { projectId, appConfigId, appConfig } = this.props
        return (
            <form className="requestForm">
                <div className="buildConfigForm">
                    <div className="dropdownContainer" tabIndex="0" ref={this.engineVersionDropDownRef}
                        aria-expanded={showEngineVersionDropdown}>
                            {history.length > 0
                                ? <div className="dropdownHeader" onClick={this.toggleEngineVersionDropDown}>{selectedEngineVersion === null ? "Select an engine version!" : `Engine Version: ${selectedEngineVersion}`}
                                    <title>Open drop down</title>
                                </div>
                                : <div className="dropdownHeader disabled">Publish a version in DreamEditor first!</div>}
                            <div className={`dropdownContent ${showEngineVersionDropdown === false ? "hidden" : ""}`}>
                                <div className="normalOption" role="listbox">
                                    {history.filter((x1, i) => i === history.findIndex((x2) => x1.editorVersion === x2.editorVersion)).map((version) =>
                                        <div className="option" key={uuidv4()} aria-label={version.editorVersion} tabIndex="0" aria-hidden="true" aria-selected="false" role="option" onClick={() => this.submitEngineVersionDropDownValue(version.editorVersion)}>
                                            {`Engine version: ${version.editorVersion}`}
                                        </div>)}
                                </div>
                                {isLoading
                                    ? <div className="loading option"><FontAwesomeIcon icon={faSpinner} spin /></div>
                                    : null}
                                {loadMore
                                    ? <div className="option" aria-hidden="true" aria-selected="false" role="option" onClick={this.loadMore} tabIndex="0">Load more... </div>
                                    : null}
                            </div>
                    </div>
                </div>
                {
                    selectedEngineVersion &&
                        <div>
                            {addNewRelease === true
                                ? <AddNewReleaseConfig
                                    cancelNewRelease={this.cancelNewRelease}
                                    selectedEngineVersion={selectedEngineVersion}
                                    history={history}
                                    getCurrentRelease={this.getCurrentRelease}
                                    appConfigId={appConfigId}
                                    projectId={projectId}
                                    appConfig={appConfig}
                                    loadMore={loadMore}
                                    isLoading={isLoading}
                                    initialLoad={initialLoad}
                                    loadMoreOnClick={this.loadMore} />
                                : <div className="buildConfigForm">
                                    <button className="addBtn" onClick={this.addNewRelease}>
                                        <FontAwesomeIcon icon={faPlus} /> New Asset Bundle Patch
                                </button>
                                </div>
                            }
                            <div className="formWrapper">
                                <div>Asset Bundle Update Roll Out Settings</div>
                                <div className="buildConfigForm">
                                    <h5 className="col title">Engine Version</h5>
                                    <h5 className="col title">Project Version</h5>
                                    <h5 className="col title">Target Release Percentage</h5>
                                </div>
                                {currentRelease.filter(x => x.releasePercentage > 0).map(version => 
                                    <div className="buildConfigForm">
                                        <h5 className="col">{version.editorVersion}</h5>
                                        <h5 className="col">{version.name}</h5>
                                        <h5 className="col">{version.releasePercentage}%</h5>
                                    </div>
                                )}
                            </div>
                            <div className="formWrapper">
                                <div>Asset Bundle Update Roll Out Status</div>
                                <div className="buildConfigForm">
                                    <h5 className="col title">Engine Version</h5>
                                    <h5 className="col title">Project Version</h5>
                                    <h5 className="col title">Rollout Users</h5>
                                    <h5 className="col title">Rollout Percentage</h5>
                                </div>
                                {currentRelease.filter(x => x.rolloutCount > 0).map(version => 
                                    <div className="buildConfigForm">
                                        <h5 className="col">{version.editorVersion}</h5>
                                        <h5 className="col">{version.name}</h5>
                                        <h5 className="col">{version.rolloutCount}</h5>
                                        <h5 className="col">{(version.rolloutPercentage * 100).toFixed(2)}%</h5>
                                    </div>
                                )}
                            </div>
                        </div>
                }
            </form>
        )
    }
}

export default ReleaseForm